import { styled } from "../../styles";

export const DashboardContainer = styled("div", {
  width: "100%",
  height: "100%",
  padding: "50px 200px",
  position: "relative",
});
